import React, {
    ReactElement,
  } from 'react';
  import {
    Routes,
    Route,
  } from 'react-router-dom';
  import DocumentLandingPage from './landing_page_documents.jsx';
  import ErrorPage from 'error_page';
  import {
    Container,
    Inner,
  } from './styles/documents_page.style.js';
  
  /**
   * Component for textbooks page. The textbooks page consists of a picture of saul goodman
   *
   * @returns {ReactElement} the textbooks page component.
   */
  
  export default function DocumentsPage() {
    return (
      <Routes>
        <Route exact path="/" element={<DocumentLandingPage />} />
        <Route exact path="*" element={<ErrorPage />} />
      </Routes>
    );
  }
  